
export const countries = [
  {
    "Name": "Antarctica",
    "Mammals": 2,
    "Birds": 5,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 3,
    "Molluscs": 0,
    "Other Inverts": 0,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 10
  },
  {
    "Name": "Bouvet Island",
    "Mammals": 1,
    "Birds": 1,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 1,
    "Molluscs": 0,
    "Other Inverts": 0,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 3
  },
  {
    "Name": "French Southern Territories",
    "Mammals": 3,
    "Birds": 14,
    "Reptiles": 7,
    "Amphibians": 0,
    "Fishes": 12,
    "Molluscs": 0,
    "Other Inverts": 0,
    "Plants": 2,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 38
  },
  {
    "Name": "Heard Island and McDonald Islands",
    "Mammals": 1,
    "Birds": 10,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 2,
    "Molluscs": 0,
    "Other Inverts": 0,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 13
  },
  {
    "Name": "South Georgia and the South Sandwich Islands",
    "Mammals": 3,
    "Birds": 6,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 2,
    "Molluscs": 0,
    "Other Inverts": 0,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 11
  },
  {
    "Name": "Anguilla",
    "Mammals": 1,
    "Birds": 0,
    "Reptiles": 8,
    "Amphibians": 0,
    "Fishes": 48,
    "Molluscs": 0,
    "Other Inverts": 25,
    "Plants": 3,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 85
  },
  {
    "Name": "Antigua and Barbuda",
    "Mammals": 2,
    "Birds": 3,
    "Reptiles": 8,
    "Amphibians": 0,
    "Fishes": 48,
    "Molluscs": 0,
    "Other Inverts": 25,
    "Plants": 2,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 88
  },
  {
    "Name": "Aruba",
    "Mammals": 2,
    "Birds": 1,
    "Reptiles": 2,
    "Amphibians": 0,
    "Fishes": 50,
    "Molluscs": 1,
    "Other Inverts": 25,
    "Plants": 5,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 86
  },
  {
    "Name": "Bahamas",
    "Mammals": 5,
    "Birds": 9,
    "Reptiles": 13,
    "Amphibians": 0,
    "Fishes": 60,
    "Molluscs": 1,
    "Other Inverts": 27,
    "Plants": 29,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 144
  },
  {
    "Name": "Barbados",
    "Mammals": 3,
    "Birds": 3,
    "Reptiles": 7,
    "Amphibians": 0,
    "Fishes": 47,
    "Molluscs": 0,
    "Other Inverts": 26,
    "Plants": 4,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 90
  },
  {
    "Name": "Bermuda",
    "Mammals": 4,
    "Birds": 3,
    "Reptiles": 4,
    "Amphibians": 0,
    "Fishes": 36,
    "Molluscs": 2,
    "Other Inverts": 35,
    "Plants": 8,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 92
  },
  {
    "Name": "Bonaire, Sint Eustatius and Saba",
    "Mammals": 3,
    "Birds": 1,
    "Reptiles": 7,
    "Amphibians": 0,
    "Fishes": 51,
    "Molluscs": 0,
    "Other Inverts": 27,
    "Plants": 7,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 96
  },
  {
    "Name": "Cayman Islands",
    "Mammals": 1,
    "Birds": 1,
    "Reptiles": 11,
    "Amphibians": 0,
    "Fishes": 43,
    "Molluscs": 2,
    "Other Inverts": 28,
    "Plants": 23,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 109
  },
  {
    "Name": "Cuba",
    "Mammals": 10,
    "Birds": 17,
    "Reptiles": 44,
    "Amphibians": 48,
    "Fishes": 65,
    "Molluscs": 0,
    "Other Inverts": 38,
    "Plants": 219,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 441
  },
  {
    "Name": "Curaçao",
    "Mammals": 3,
    "Birds": 1,
    "Reptiles": 5,
    "Amphibians": 0,
    "Fishes": 46,
    "Molluscs": 0,
    "Other Inverts": 26,
    "Plants": 5,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 86
  },
  {
    "Name": "Dominica",
    "Mammals": 3,
    "Birds": 6,
    "Reptiles": 3,
    "Amphibians": 2,
    "Fishes": 49,
    "Molluscs": 0,
    "Other Inverts": 25,
    "Plants": 20,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 108
  },
  {
    "Name": "Dominican Republic",
    "Mammals": 5,
    "Birds": 17,
    "Reptiles": 58,
    "Amphibians": 35,
    "Fishes": 47,
    "Molluscs": 0,
    "Other Inverts": 35,
    "Plants": 151,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 348
  },
  {
    "Name": "Grenada",
    "Mammals": 3,
    "Birds": 2,
    "Reptiles": 7,
    "Amphibians": 1,
    "Fishes": 48,
    "Molluscs": 0,
    "Other Inverts": 26,
    "Plants": 7,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 94
  },
  {
    "Name": "Guadeloupe",
    "Mammals": 4,
    "Birds": 4,
    "Reptiles": 14,
    "Amphibians": 3,
    "Fishes": 47,
    "Molluscs": 1,
    "Other Inverts": 29,
    "Plants": 20,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 122
  },
  {
    "Name": "Haiti",
    "Mammals": 2,
    "Birds": 17,
    "Reptiles": 67,
    "Amphibians": 45,
    "Fishes": 61,
    "Molluscs": 0,
    "Other Inverts": 30,
    "Plants": 277,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 499
  },
  {
    "Name": "Jamaica",
    "Mammals": 7,
    "Birds": 10,
    "Reptiles": 28,
    "Amphibians": 20,
    "Fishes": 48,
    "Molluscs": 0,
    "Other Inverts": 30,
    "Plants": 213,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 356
  },
  {
    "Name": "Martinique",
    "Mammals": 1,
    "Birds": 5,
    "Reptiles": 9,
    "Amphibians": 2,
    "Fishes": 45,
    "Molluscs": 2,
    "Other Inverts": 23,
    "Plants": 19,
    "Fungi": 1,
    "Chromists": 0,
    "Total": 107
  },
  {
    "Name": "Montserrat",
    "Mammals": 2,
    "Birds": 3,
    "Reptiles": 4,
    "Amphibians": 1,
    "Fishes": 45,
    "Molluscs": 0,
    "Other Inverts": 25,
    "Plants": 8,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 88
  },
  {
    "Name": "Puerto Rico",
    "Mammals": 2,
    "Birds": 13,
    "Reptiles": 16,
    "Amphibians": 14,
    "Fishes": 49,
    "Molluscs": 0,
    "Other Inverts": 25,
    "Plants": 78,
    "Fungi": 1,
    "Chromists": 0,
    "Total": 198
  },
  {
    "Name": "Saint Barthélemy",
    "Mammals": 1,
    "Birds": 0,
    "Reptiles": 4,
    "Amphibians": 0,
    "Fishes": 36,
    "Molluscs": 0,
    "Other Inverts": 25,
    "Plants": 2,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 68
  },
  {
    "Name": "Saint Kitts and Nevis",
    "Mammals": 2,
    "Birds": 3,
    "Reptiles": 6,
    "Amphibians": 1,
    "Fishes": 46,
    "Molluscs": 0,
    "Other Inverts": 25,
    "Plants": 5,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 88
  },
  {
    "Name": "Saint Lucia",
    "Mammals": 2,
    "Birds": 7,
    "Reptiles": 9,
    "Amphibians": 0,
    "Fishes": 46,
    "Molluscs": 0,
    "Other Inverts": 25,
    "Plants": 16,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 105
  },
  {
    "Name": "Saint Martin (French part)",
    "Mammals": 2,
    "Birds": 1,
    "Reptiles": 7,
    "Amphibians": 0,
    "Fishes": 44,
    "Molluscs": 0,
    "Other Inverts": 25,
    "Plants": 2,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 81
  },
  {
    "Name": "Saint Vincent and the Grenadines",
    "Mammals": 2,
    "Birds": 4,
    "Reptiles": 8,
    "Amphibians": 1,
    "Fishes": 47,
    "Molluscs": 0,
    "Other Inverts": 25,
    "Plants": 8,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 95
  },
  {
    "Name": "Sint Maarten (Dutch part)",
    "Mammals": 2,
    "Birds": 1,
    "Reptiles": 7,
    "Amphibians": 0,
    "Fishes": 44,
    "Molluscs": 0,
    "Other Inverts": 25,
    "Plants": 1,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 80
  },
  {
    "Name": "Trinidad and Tobago",
    "Mammals": 3,
    "Birds": 4,
    "Reptiles": 7,
    "Amphibians": 4,
    "Fishes": 61,
    "Molluscs": 0,
    "Other Inverts": 26,
    "Plants": 64,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 169
  },
  {
    "Name": "Turks and Caicos Islands",
    "Mammals": 2,
    "Birds": 3,
    "Reptiles": 8,
    "Amphibians": 0,
    "Fishes": 45,
    "Molluscs": 0,
    "Other Inverts": 25,
    "Plants": 11,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 94
  },
  {
    "Name": "Virgin Islands, British",
    "Mammals": 1,
    "Birds": 2,
    "Reptiles": 15,
    "Amphibians": 2,
    "Fishes": 47,
    "Molluscs": 0,
    "Other Inverts": 25,
    "Plants": 26,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 118
  },
  {
    "Name": "Virgin Islands, U.S.",
    "Mammals": 1,
    "Birds": 3,
    "Reptiles": 14,
    "Amphibians": 3,
    "Fishes": 47,
    "Molluscs": 0,
    "Other Inverts": 23,
    "Plants": 23,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 114
  },
  {
    "Name": "China",
    "Mammals": 77,
    "Birds": 94,
    "Reptiles": 56,
    "Amphibians": 149,
    "Fishes": 329,
    "Molluscs": 15,
    "Other Inverts": 94,
    "Plants": 816,
    "Fungi": 8,
    "Chromists": 0,
    "Total": 1638
  },
  {
    "Name": "Hong Kong",
    "Mammals": 6,
    "Birds": 22,
    "Reptiles": 8,
    "Amphibians": 6,
    "Fishes": 35,
    "Molluscs": 1,
    "Other Inverts": 14,
    "Plants": 16,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 108
  },
  {
    "Name": "Japan",
    "Mammals": 29,
    "Birds": 50,
    "Reptiles": 26,
    "Amphibians": 45,
    "Fishes": 170,
    "Molluscs": 61,
    "Other Inverts": 144,
    "Plants": 74,
    "Fungi": 15,
    "Chromists": 0,
    "Total": 614
  },
  {
    "Name": "Korea, Democratic People's Republic of",
    "Mammals": 10,
    "Birds": 31,
    "Reptiles": 2,
    "Amphibians": 2,
    "Fishes": 52,
    "Molluscs": 0,
    "Other Inverts": 4,
    "Plants": 20,
    "Fungi": 2,
    "Chromists": 0,
    "Total": 123
  },
  {
    "Name": "Korea, Republic of",
    "Mammals": 12,
    "Birds": 35,
    "Reptiles": 3,
    "Amphibians": 9,
    "Fishes": 81,
    "Molluscs": 6,
    "Other Inverts": 15,
    "Plants": 38,
    "Fungi": 3,
    "Chromists": 0,
    "Total": 202
  },
  {
    "Name": "Macao",
    "Mammals": 0,
    "Birds": 4,
    "Reptiles": 2,
    "Amphibians": 1,
    "Fishes": 21,
    "Molluscs": 0,
    "Other Inverts": 1,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 29
  },
  {
    "Name": "Mongolia",
    "Mammals": 10,
    "Birds": 24,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 1,
    "Molluscs": 0,
    "Other Inverts": 2,
    "Plants": 1,
    "Fungi": 4,
    "Chromists": 0,
    "Total": 42
  },
  {
    "Name": "Taiwan, Province of China",
    "Mammals": 12,
    "Birds": 25,
    "Reptiles": 15,
    "Amphibians": 10,
    "Fishes": 150,
    "Molluscs": 2,
    "Other Inverts": 128,
    "Plants": 88,
    "Fungi": 2,
    "Chromists": 0,
    "Total": 432
  },
  {
    "Name": "Åland Islands",
    "Mammals": 0,
    "Birds": 0,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 0,
    "Molluscs": 0,
    "Other Inverts": 0,
    "Plants": 1,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 1
  },
  {
    "Name": "Albania",
    "Mammals": 4,
    "Birds": 8,
    "Reptiles": 6,
    "Amphibians": 3,
    "Fishes": 61,
    "Molluscs": 54,
    "Other Inverts": 24,
    "Plants": 5,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 165
  },
  {
    "Name": "Andorra",
    "Mammals": 3,
    "Birds": 3,
    "Reptiles": 2,
    "Amphibians": 1,
    "Fishes": 0,
    "Molluscs": 2,
    "Other Inverts": 5,
    "Plants": 1,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 17
  },
  {
    "Name": "Austria",
    "Mammals": 5,
    "Birds": 13,
    "Reptiles": 1,
    "Amphibians": 2,
    "Fishes": 13,
    "Molluscs": 45,
    "Other Inverts": 65,
    "Plants": 38,
    "Fungi": 51,
    "Chromists": 0,
    "Total": 233
  },
  {
    "Name": "Belgium",
    "Mammals": 3,
    "Birds": 8,
    "Reptiles": 0,
    "Amphibians": 1,
    "Fishes": 21,
    "Molluscs": 7,
    "Other Inverts": 17,
    "Plants": 3,
    "Fungi": 25,
    "Chromists": 0,
    "Total": 85
  },
  {
    "Name": "Bosnia and Herzegovina",
    "Mammals": 5,
    "Birds": 9,
    "Reptiles": 3,
    "Amphibians": 4,
    "Fishes": 53,
    "Molluscs": 22,
    "Other Inverts": 39,
    "Plants": 5,
    "Fungi": 1,
    "Chromists": 0,
    "Total": 141
  },
  {
    "Name": "Bulgaria",
    "Mammals": 10,
    "Birds": 18,
    "Reptiles": 3,
    "Amphibians": 2,
    "Fishes": 21,
    "Molluscs": 35,
    "Other Inverts": 40,
    "Plants": 13,
    "Fungi": 9,
    "Chromists": 0,
    "Total": 151
  },
  {
    "Name": "Croatia",
    "Mammals": 9,
    "Birds": 15,
    "Reptiles": 4,
    "Amphibians": 4,
    "Fishes": 80,
    "Molluscs": 56,
    "Other Inverts": 46,
    "Plants": 10,
    "Fungi": 26,
    "Chromists": 0,
    "Total": 250
  },
  {
    "Name": "Czechia",
    "Mammals": 5,
    "Birds": 10,
    "Reptiles": 0,
    "Amphibians": 2,
    "Fishes": 2,
    "Molluscs": 8,
    "Other Inverts": 41,
    "Plants": 31,
    "Fungi": 34,
    "Chromists": 0,
    "Total": 133
  },
  {
    "Name": "Denmark",
    "Mammals": 2,
    "Birds": 10,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 27,
    "Molluscs": 6,
    "Other Inverts": 15,
    "Plants": 2,
    "Fungi": 32,
    "Chromists": 0,
    "Total": 94
  },
  {
    "Name": "Estonia",
    "Mammals": 1,
    "Birds": 11,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 4,
    "Molluscs": 4,
    "Other Inverts": 6,
    "Plants": 2,
    "Fungi": 29,
    "Chromists": 0,
    "Total": 57
  },
  {
    "Name": "Faroe Islands",
    "Mammals": 4,
    "Birds": 5,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 22,
    "Molluscs": 0,
    "Other Inverts": 0,
    "Plants": 1,
    "Fungi": 4,
    "Chromists": 0,
    "Total": 36
  },
  {
    "Name": "Finland",
    "Mammals": 2,
    "Birds": 12,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 5,
    "Molluscs": 4,
    "Other Inverts": 13,
    "Plants": 4,
    "Fungi": 31,
    "Chromists": 0,
    "Total": 71
  },
  {
    "Name": "France",
    "Mammals": 13,
    "Birds": 19,
    "Reptiles": 6,
    "Amphibians": 6,
    "Fishes": 78,
    "Molluscs": 97,
    "Other Inverts": 132,
    "Plants": 66,
    "Fungi": 63,
    "Chromists": 0,
    "Total": 480
  },
  {
    "Name": "Germany",
    "Mammals": 7,
    "Birds": 12,
    "Reptiles": 1,
    "Amphibians": 2,
    "Fishes": 35,
    "Molluscs": 32,
    "Other Inverts": 69,
    "Plants": 51,
    "Fungi": 55,
    "Chromists": 0,
    "Total": 264
  },
  {
    "Name": "Gibraltar",
    "Mammals": 4,
    "Birds": 10,
    "Reptiles": 0,
    "Amphibians": 1,
    "Fishes": 37,
    "Molluscs": 5,
    "Other Inverts": 4,
    "Plants": 1,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 62
  },
  {
    "Name": "Greece",
    "Mammals": 12,
    "Birds": 18,
    "Reptiles": 7,
    "Amphibians": 6,
    "Fishes": 95,
    "Molluscs": 188,
    "Other Inverts": 178,
    "Plants": 86,
    "Fungi": 11,
    "Chromists": 0,
    "Total": 602
  },
  {
    "Name": "Greenland",
    "Mammals": 9,
    "Birds": 6,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 13,
    "Molluscs": 0,
    "Other Inverts": 0,
    "Plants": 1,
    "Fungi": 2,
    "Chromists": 0,
    "Total": 31
  },
  {
    "Name": "Guernsey",
    "Mammals": 0,
    "Birds": 0,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 15,
    "Molluscs": 1,
    "Other Inverts": 0,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 16
  },
  {
    "Name": "Holy See (Vatican City State)",
    "Mammals": 2,
    "Birds": 0,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 0,
    "Molluscs": 0,
    "Other Inverts": 0,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 2
  },
  {
    "Name": "Hungary",
    "Mammals": 6,
    "Birds": 14,
    "Reptiles": 1,
    "Amphibians": 2,
    "Fishes": 11,
    "Molluscs": 10,
    "Other Inverts": 38,
    "Plants": 45,
    "Fungi": 21,
    "Chromists": 0,
    "Total": 148
  },
  {
    "Name": "Iceland",
    "Mammals": 6,
    "Birds": 7,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 22,
    "Molluscs": 0,
    "Other Inverts": 1,
    "Plants": 0,
    "Fungi": 6,
    "Chromists": 0,
    "Total": 42
  },
  {
    "Name": "Ireland",
    "Mammals": 4,
    "Birds": 9,
    "Reptiles": 1,
    "Amphibians": 0,
    "Fishes": 46,
    "Molluscs": 5,
    "Other Inverts": 3,
    "Plants": 8,
    "Fungi": 22,
    "Chromists": 0,
    "Total": 98
  },
  {
    "Name": "Isle of Man",
    "Mammals": 0,
    "Birds": 0,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 9,
    "Molluscs": 0,
    "Other Inverts": 0,
    "Plants": 1,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 10
  },
  {
    "Name": "Italy",
    "Mammals": 9,
    "Birds": 17,
    "Reptiles": 6,
    "Amphibians": 13,
    "Fishes": 73,
    "Molluscs": 89,
    "Other Inverts": 191,
    "Plants": 121,
    "Fungi": 50,
    "Chromists": 0,
    "Total": 569
  },
  {
    "Name": "Jersey",
    "Mammals": 0,
    "Birds": 0,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 15,
    "Molluscs": 2,
    "Other Inverts": 0,
    "Plants": 0,
    "Fungi": 1,
    "Chromists": 0,
    "Total": 18
  },
  {
    "Name": "Latvia",
    "Mammals": 1,
    "Birds": 13,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 6,
    "Molluscs": 4,
    "Other Inverts": 12,
    "Plants": 1,
    "Fungi": 11,
    "Chromists": 0,
    "Total": 48
  },
  {
    "Name": "Liechtenstein",
    "Mammals": 0,
    "Birds": 3,
    "Reptiles": 0,
    "Amphibians": 1,
    "Fishes": 0,
    "Molluscs": 2,
    "Other Inverts": 6,
    "Plants": 1,
    "Fungi": 4,
    "Chromists": 0,
    "Total": 17
  },
  {
    "Name": "Lithuania",
    "Mammals": 1,
    "Birds": 11,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 6,
    "Molluscs": 4,
    "Other Inverts": 7,
    "Plants": 2,
    "Fungi": 15,
    "Chromists": 0,
    "Total": 46
  },
  {
    "Name": "Luxembourg",
    "Mammals": 0,
    "Birds": 3,
    "Reptiles": 0,
    "Amphibians": 1,
    "Fishes": 1,
    "Molluscs": 7,
    "Other Inverts": 4,
    "Plants": 3,
    "Fungi": 2,
    "Chromists": 0,
    "Total": 21
  },
  {
    "Name": "Malta",
    "Mammals": 3,
    "Birds": 6,
    "Reptiles": 1,
    "Amphibians": 0,
    "Fishes": 44,
    "Molluscs": 5,
    "Other Inverts": 7,
    "Plants": 4,
    "Fungi": 1,
    "Chromists": 0,
    "Total": 71
  },
  {
    "Name": "Monaco",
    "Mammals": 5,
    "Birds": 0,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 38,
    "Molluscs": 2,
    "Other Inverts": 3,
    "Plants": 2,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 50
  },
  {
    "Name": "Montenegro",
    "Mammals": 7,
    "Birds": 12,
    "Reptiles": 4,
    "Amphibians": 3,
    "Fishes": 53,
    "Molluscs": 27,
    "Other Inverts": 57,
    "Plants": 6,
    "Fungi": 4,
    "Chromists": 0,
    "Total": 173
  },
  {
    "Name": "Netherlands",
    "Mammals": 4,
    "Birds": 10,
    "Reptiles": 0,
    "Amphibians": 1,
    "Fishes": 23,
    "Molluscs": 7,
    "Other Inverts": 13,
    "Plants": 3,
    "Fungi": 29,
    "Chromists": 0,
    "Total": 90
  },
  {
    "Name": "North Macedonia",
    "Mammals": 7,
    "Birds": 12,
    "Reptiles": 3,
    "Amphibians": 2,
    "Fishes": 13,
    "Molluscs": 71,
    "Other Inverts": 28,
    "Plants": 6,
    "Fungi": 7,
    "Chromists": 0,
    "Total": 149
  },
  {
    "Name": "Norway",
    "Mammals": 8,
    "Birds": 11,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 34,
    "Molluscs": 4,
    "Other Inverts": 12,
    "Plants": 20,
    "Fungi": 49,
    "Chromists": 0,
    "Total": 138
  },
  {
    "Name": "Poland",
    "Mammals": 4,
    "Birds": 13,
    "Reptiles": 0,
    "Amphibians": 1,
    "Fishes": 9,
    "Molluscs": 9,
    "Other Inverts": 35,
    "Plants": 16,
    "Fungi": 30,
    "Chromists": 0,
    "Total": 117
  },
  {
    "Name": "Portugal",
    "Mammals": 15,
    "Birds": 17,
    "Reptiles": 4,
    "Amphibians": 4,
    "Fishes": 89,
    "Molluscs": 86,
    "Other Inverts": 170,
    "Plants": 141,
    "Fungi": 14,
    "Chromists": 0,
    "Total": 540
  },
  {
    "Name": "Romania",
    "Mammals": 14,
    "Birds": 18,
    "Reptiles": 3,
    "Amphibians": 1,
    "Fishes": 21,
    "Molluscs": 27,
    "Other Inverts": 67,
    "Plants": 14,
    "Fungi": 9,
    "Chromists": 0,
    "Total": 174
  },
  {
    "Name": "San Marino",
    "Mammals": 1,
    "Birds": 1,
    "Reptiles": 0,
    "Amphibians": 1,
    "Fishes": 2,
    "Molluscs": 1,
    "Other Inverts": 0,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 6
  },
  {
    "Name": "Serbia",
    "Mammals": 8,
    "Birds": 14,
    "Reptiles": 2,
    "Amphibians": 2,
    "Fishes": 14,
    "Molluscs": 10,
    "Other Inverts": 60,
    "Plants": 9,
    "Fungi": 7,
    "Chromists": 0,
    "Total": 126
  },
  {
    "Name": "Slovakia",
    "Mammals": 5,
    "Birds": 13,
    "Reptiles": 0,
    "Amphibians": 1,
    "Fishes": 7,
    "Molluscs": 9,
    "Other Inverts": 37,
    "Plants": 32,
    "Fungi": 33,
    "Chromists": 0,
    "Total": 137
  },
  {
    "Name": "Slovenia",
    "Mammals": 8,
    "Birds": 11,
    "Reptiles": 3,
    "Amphibians": 4,
    "Fishes": 53,
    "Molluscs": 36,
    "Other Inverts": 69,
    "Plants": 12,
    "Fungi": 22,
    "Chromists": 0,
    "Total": 218
  },
  {
    "Name": "Spain",
    "Mammals": 18,
    "Birds": 23,
    "Reptiles": 19,
    "Amphibians": 9,
    "Fishes": 99,
    "Molluscs": 168,
    "Other Inverts": 186,
    "Plants": 291,
    "Fungi": 50,
    "Chromists": 0,
    "Total": 863
  },
  {
    "Name": "Svalbard and Jan Mayen",
    "Mammals": 4,
    "Birds": 4,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 5,
    "Molluscs": 0,
    "Other Inverts": 0,
    "Plants": 1,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 14
  },
  {
    "Name": "Sweden",
    "Mammals": 1,
    "Birds": 12,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 25,
    "Molluscs": 5,
    "Other Inverts": 16,
    "Plants": 12,
    "Fungi": 49,
    "Chromists": 0,
    "Total": 120
  },
  {
    "Name": "Switzerland",
    "Mammals": 5,
    "Birds": 10,
    "Reptiles": 1,
    "Amphibians": 3,
    "Fishes": 9,
    "Molluscs": 12,
    "Other Inverts": 74,
    "Plants": 20,
    "Fungi": 44,
    "Chromists": 0,
    "Total": 178
  },
  {
    "Name": "United Kingdom",
    "Mammals": 4,
    "Birds": 12,
    "Reptiles": 1,
    "Amphibians": 0,
    "Fishes": 63,
    "Molluscs": 8,
    "Other Inverts": 24,
    "Plants": 53,
    "Fungi": 43,
    "Chromists": 0,
    "Total": 208
  },
  {
    "Name": "Belize",
    "Mammals": 10,
    "Birds": 7,
    "Reptiles": 8,
    "Amphibians": 2,
    "Fishes": 67,
    "Molluscs": 0,
    "Other Inverts": 27,
    "Plants": 114,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 235
  },
  {
    "Name": "Costa Rica",
    "Mammals": 12,
    "Birds": 24,
    "Reptiles": 16,
    "Amphibians": 56,
    "Fishes": 138,
    "Molluscs": 2,
    "Other Inverts": 57,
    "Plants": 463,
    "Fungi": 6,
    "Chromists": 0,
    "Total": 774
  },
  {
    "Name": "El Salvador",
    "Mammals": 6,
    "Birds": 9,
    "Reptiles": 10,
    "Amphibians": 8,
    "Fishes": 52,
    "Molluscs": 0,
    "Other Inverts": 11,
    "Plants": 106,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 202
  },
  {
    "Name": "Guatemala",
    "Mammals": 16,
    "Birds": 18,
    "Reptiles": 39,
    "Amphibians": 96,
    "Fishes": 98,
    "Molluscs": 2,
    "Other Inverts": 36,
    "Plants": 470,
    "Fungi": 1,
    "Chromists": 0,
    "Total": 776
  },
  {
    "Name": "Honduras",
    "Mammals": 10,
    "Birds": 17,
    "Reptiles": 60,
    "Amphibians": 70,
    "Fishes": 89,
    "Molluscs": 0,
    "Other Inverts": 36,
    "Plants": 214,
    "Fungi": 2,
    "Chromists": 0,
    "Total": 498
  },
  {
    "Name": "Mexico",
    "Mammals": 97,
    "Birds": 67,
    "Reptiles": 106,
    "Amphibians": 232,
    "Fishes": 305,
    "Molluscs": 14,
    "Other Inverts": 152,
    "Plants": 1632,
    "Fungi": 7,
    "Chromists": 0,
    "Total": 2614
  },
  {
    "Name": "Nicaragua",
    "Mammals": 9,
    "Birds": 18,
    "Reptiles": 11,
    "Amphibians": 11,
    "Fishes": 97,
    "Molluscs": 2,
    "Other Inverts": 33,
    "Plants": 129,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 310
  },
  {
    "Name": "Panama",
    "Mammals": 18,
    "Birds": 17,
    "Reptiles": 16,
    "Amphibians": 78,
    "Fishes": 128,
    "Molluscs": 0,
    "Other Inverts": 40,
    "Plants": 288,
    "Fungi": 3,
    "Chromists": 0,
    "Total": 588
  },
  {
    "Name": "Algeria",
    "Mammals": 18,
    "Birds": 19,
    "Reptiles": 7,
    "Amphibians": 2,
    "Fishes": 66,
    "Molluscs": 10,
    "Other Inverts": 33,
    "Plants": 31,
    "Fungi": 2,
    "Chromists": 0,
    "Total": 188
  },
  {
    "Name": "Egypt",
    "Mammals": 20,
    "Birds": 16,
    "Reptiles": 12,
    "Amphibians": 0,
    "Fishes": 95,
    "Molluscs": 2,
    "Other Inverts": 58,
    "Plants": 13,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 216
  },
  {
    "Name": "Libya",
    "Mammals": 12,
    "Birds": 10,
    "Reptiles": 6,
    "Amphibians": 0,
    "Fishes": 53,
    "Molluscs": 1,
    "Other Inverts": 5,
    "Plants": 8,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 95
  },
  {
    "Name": "Morocco",
    "Mammals": 21,
    "Birds": 21,
    "Reptiles": 12,
    "Amphibians": 3,
    "Fishes": 86,
    "Molluscs": 49,
    "Other Inverts": 35,
    "Plants": 58,
    "Fungi": 7,
    "Chromists": 0,
    "Total": 292
  },
  {
    "Name": "Tunisia",
    "Mammals": 15,
    "Birds": 13,
    "Reptiles": 5,
    "Amphibians": 0,
    "Fishes": 60,
    "Molluscs": 8,
    "Other Inverts": 15,
    "Plants": 12,
    "Fungi": 2,
    "Chromists": 0,
    "Total": 130
  },
  {
    "Name": "Western Sahara",
    "Mammals": 12,
    "Birds": 6,
    "Reptiles": 1,
    "Amphibians": 0,
    "Fishes": 64,
    "Molluscs": 2,
    "Other Inverts": 1,
    "Plants": 1,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 87
  },
  {
    "Name": "Canada",
    "Mammals": 18,
    "Birds": 22,
    "Reptiles": 6,
    "Amphibians": 1,
    "Fishes": 52,
    "Molluscs": 21,
    "Other Inverts": 24,
    "Plants": 21,
    "Fungi": 30,
    "Chromists": 0,
    "Total": 196
  },
  {
    "Name": "Saint Pierre and Miquelon",
    "Mammals": 4,
    "Birds": 9,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 13,
    "Molluscs": 0,
    "Other Inverts": 0,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 26
  },
  {
    "Name": "United States of America",
    "Mammals": 43,
    "Birds": 82,
    "Reptiles": 39,
    "Amphibians": 66,
    "Fishes": 282,
    "Molluscs": 320,
    "Other Inverts": 350,
    "Plants": 749,
    "Fungi": 88,
    "Chromists": 0,
    "Total": 2021
  },
  {
    "Name": "Belarus",
    "Mammals": 4,
    "Birds": 11,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 3,
    "Molluscs": 4,
    "Other Inverts": 9,
    "Plants": 2,
    "Fungi": 4,
    "Chromists": 0,
    "Total": 37
  },
  {
    "Name": "Moldova",
    "Mammals": 6,
    "Birds": 12,
    "Reptiles": 2,
    "Amphibians": 0,
    "Fishes": 8,
    "Molluscs": 3,
    "Other Inverts": 4,
    "Plants": 2,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 37
  },
  {
    "Name": "Russian Federation",
    "Mammals": 33,
    "Birds": 58,
    "Reptiles": 8,
    "Amphibians": 0,
    "Fishes": 64,
    "Molluscs": 7,
    "Other Inverts": 38,
    "Plants": 68,
    "Fungi": 42,
    "Chromists": 0,
    "Total": 318
  },
  {
    "Name": "Ukraine",
    "Mammals": 13,
    "Birds": 18,
    "Reptiles": 2,
    "Amphibians": 1,
    "Fishes": 25,
    "Molluscs": 10,
    "Other Inverts": 38,
    "Plants": 29,
    "Fungi": 14,
    "Chromists": 0,
    "Total": 150
  },
  {
    "Name": "American Samoa",
    "Mammals": 1,
    "Birds": 6,
    "Reptiles": 6,
    "Amphibians": 0,
    "Fishes": 27,
    "Molluscs": 5,
    "Other Inverts": 61,
    "Plants": 3,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 109
  },
  {
    "Name": "Australia",
    "Mammals": 70,
    "Birds": 67,
    "Reptiles": 76,
    "Amphibians": 46,
    "Fishes": 218,
    "Molluscs": 182,
    "Other Inverts": 423,
    "Plants": 798,
    "Fungi": 14,
    "Chromists": 0,
    "Total": 1895
  },
  {
    "Name": "Christmas Island",
    "Mammals": 2,
    "Birds": 5,
    "Reptiles": 3,
    "Amphibians": 0,
    "Fishes": 24,
    "Molluscs": 0,
    "Other Inverts": 20,
    "Plants": 2,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 56
  },
  {
    "Name": "Cocos (Keeling) Islands",
    "Mammals": 2,
    "Birds": 1,
    "Reptiles": 1,
    "Amphibians": 0,
    "Fishes": 25,
    "Molluscs": 0,
    "Other Inverts": 21,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 50
  },
  {
    "Name": "Cook Islands",
    "Mammals": 1,
    "Birds": 10,
    "Reptiles": 3,
    "Amphibians": 0,
    "Fishes": 21,
    "Molluscs": 1,
    "Other Inverts": 33,
    "Plants": 13,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 82
  },
  {
    "Name": "Fiji",
    "Mammals": 7,
    "Birds": 14,
    "Reptiles": 16,
    "Amphibians": 0,
    "Fishes": 36,
    "Molluscs": 85,
    "Other Inverts": 108,
    "Plants": 96,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 362
  },
  {
    "Name": "French Polynesia",
    "Mammals": 0,
    "Birds": 35,
    "Reptiles": 3,
    "Amphibians": 0,
    "Fishes": 41,
    "Molluscs": 41,
    "Other Inverts": 35,
    "Plants": 293,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 448
  },
  {
    "Name": "Guam",
    "Mammals": 3,
    "Birds": 13,
    "Reptiles": 5,
    "Amphibians": 0,
    "Fishes": 26,
    "Molluscs": 6,
    "Other Inverts": 54,
    "Plants": 5,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 112
  },
  {
    "Name": "Kiribati",
    "Mammals": 2,
    "Birds": 5,
    "Reptiles": 2,
    "Amphibians": 0,
    "Fishes": 25,
    "Molluscs": 1,
    "Other Inverts": 81,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 116
  },
  {
    "Name": "Marshall Islands",
    "Mammals": 1,
    "Birds": 6,
    "Reptiles": 4,
    "Amphibians": 0,
    "Fishes": 29,
    "Molluscs": 1,
    "Other Inverts": 73,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 114
  },
  {
    "Name": "Micronesia, Federated States of",
    "Mammals": 6,
    "Birds": 14,
    "Reptiles": 8,
    "Amphibians": 0,
    "Fishes": 34,
    "Molluscs": 3,
    "Other Inverts": 117,
    "Plants": 15,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 197
  },
  {
    "Name": "Nauru",
    "Mammals": 2,
    "Birds": 3,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 22,
    "Molluscs": 0,
    "Other Inverts": 69,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 96
  },
  {
    "Name": "New Caledonia",
    "Mammals": 8,
    "Birds": 19,
    "Reptiles": 72,
    "Amphibians": 0,
    "Fishes": 54,
    "Molluscs": 28,
    "Other Inverts": 102,
    "Plants": 717,
    "Fungi": 4,
    "Chromists": 0,
    "Total": 1004
  },
  {
    "Name": "New Zealand",
    "Mammals": 9,
    "Birds": 67,
    "Reptiles": 52,
    "Amphibians": 3,
    "Fishes": 49,
    "Molluscs": 39,
    "Other Inverts": 26,
    "Plants": 21,
    "Fungi": 13,
    "Chromists": 0,
    "Total": 279
  },
  {
    "Name": "Niue",
    "Mammals": 1,
    "Birds": 7,
    "Reptiles": 4,
    "Amphibians": 0,
    "Fishes": 21,
    "Molluscs": 0,
    "Other Inverts": 31,
    "Plants": 2,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 66
  },
  {
    "Name": "Norfolk Island",
    "Mammals": 1,
    "Birds": 11,
    "Reptiles": 2,
    "Amphibians": 0,
    "Fishes": 14,
    "Molluscs": 12,
    "Other Inverts": 12,
    "Plants": 2,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 54
  },
  {
    "Name": "Northern Mariana Islands",
    "Mammals": 3,
    "Birds": 14,
    "Reptiles": 4,
    "Amphibians": 0,
    "Fishes": 26,
    "Molluscs": 4,
    "Other Inverts": 53,
    "Plants": 7,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 111
  },
  {
    "Name": "Palau",
    "Mammals": 5,
    "Birds": 7,
    "Reptiles": 4,
    "Amphibians": 0,
    "Fishes": 35,
    "Molluscs": 41,
    "Other Inverts": 109,
    "Plants": 9,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 210
  },
  {
    "Name": "Papua New Guinea",
    "Mammals": 50,
    "Birds": 33,
    "Reptiles": 13,
    "Amphibians": 27,
    "Fishes": 139,
    "Molluscs": 24,
    "Other Inverts": 182,
    "Plants": 733,
    "Fungi": 3,
    "Chromists": 0,
    "Total": 1204
  },
  {
    "Name": "Pitcairn",
    "Mammals": 0,
    "Birds": 9,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 12,
    "Molluscs": 5,
    "Other Inverts": 12,
    "Plants": 10,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 48
  },
  {
    "Name": "Samoa",
    "Mammals": 2,
    "Birds": 4,
    "Reptiles": 4,
    "Amphibians": 0,
    "Fishes": 29,
    "Molluscs": 5,
    "Other Inverts": 64,
    "Plants": 15,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 123
  },
  {
    "Name": "Solomon Islands",
    "Mammals": 24,
    "Birds": 17,
    "Reptiles": 7,
    "Amphibians": 3,
    "Fishes": 45,
    "Molluscs": 4,
    "Other Inverts": 148,
    "Plants": 62,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 310
  },
  {
    "Name": "Tokelau",
    "Mammals": 0,
    "Birds": 0,
    "Reptiles": 3,
    "Amphibians": 0,
    "Fishes": 23,
    "Molluscs": 0,
    "Other Inverts": 36,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 62
  },
  {
    "Name": "Tonga",
    "Mammals": 2,
    "Birds": 5,
    "Reptiles": 4,
    "Amphibians": 0,
    "Fishes": 30,
    "Molluscs": 25,
    "Other Inverts": 45,
    "Plants": 10,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 121
  },
  {
    "Name": "Tuvalu",
    "Mammals": 2,
    "Birds": 0,
    "Reptiles": 4,
    "Amphibians": 0,
    "Fishes": 23,
    "Molluscs": 1,
    "Other Inverts": 78,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 108
  },
  {
    "Name": "United States Minor Outlying Islands",
    "Mammals": 0,
    "Birds": 10,
    "Reptiles": 1,
    "Amphibians": 0,
    "Fishes": 18,
    "Molluscs": 0,
    "Other Inverts": 38,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 67
  },
  {
    "Name": "Vanuatu",
    "Mammals": 8,
    "Birds": 9,
    "Reptiles": 5,
    "Amphibians": 0,
    "Fishes": 34,
    "Molluscs": 6,
    "Other Inverts": 89,
    "Plants": 30,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 181
  },
  {
    "Name": "Wallis and Futuna",
    "Mammals": 0,
    "Birds": 7,
    "Reptiles": 2,
    "Amphibians": 0,
    "Fishes": 23,
    "Molluscs": 1,
    "Other Inverts": 64,
    "Plants": 3,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 100
  },
  {
    "Name": "Argentina",
    "Mammals": 39,
    "Birds": 55,
    "Reptiles": 29,
    "Amphibians": 32,
    "Fishes": 119,
    "Molluscs": 0,
    "Other Inverts": 19,
    "Plants": 80,
    "Fungi": 32,
    "Chromists": 0,
    "Total": 405
  },
  {
    "Name": "Bolivia",
    "Mammals": 24,
    "Birds": 45,
    "Reptiles": 14,
    "Amphibians": 53,
    "Fishes": 41,
    "Molluscs": 2,
    "Other Inverts": 1,
    "Plants": 400,
    "Fungi": 3,
    "Chromists": 0,
    "Total": 583
  },
  {
    "Name": "Brazil",
    "Mammals": 97,
    "Birds": 145,
    "Reptiles": 94,
    "Amphibians": 189,
    "Fishes": 439,
    "Molluscs": 22,
    "Other Inverts": 89,
    "Plants": 1362,
    "Fungi": 38,
    "Chromists": 0,
    "Total": 2475
  },
  {
    "Name": "Chile",
    "Mammals": 18,
    "Birds": 36,
    "Reptiles": 28,
    "Amphibians": 35,
    "Fishes": 62,
    "Molluscs": 1,
    "Other Inverts": 13,
    "Plants": 110,
    "Fungi": 22,
    "Chromists": 0,
    "Total": 326
  },
  {
    "Name": "Colombia",
    "Mammals": 62,
    "Birds": 86,
    "Reptiles": 40,
    "Amphibians": 300,
    "Fishes": 194,
    "Molluscs": 4,
    "Other Inverts": 78,
    "Plants": 953,
    "Fungi": 22,
    "Chromists": 0,
    "Total": 1739
  },
  {
    "Name": "Ecuador",
    "Mammals": 49,
    "Birds": 77,
    "Reptiles": 93,
    "Amphibians": 292,
    "Fishes": 83,
    "Molluscs": 49,
    "Other Inverts": 28,
    "Plants": 2061,
    "Fungi": 3,
    "Chromists": 6,
    "Total": 2741
  },
  {
    "Name": "Falkland Islands (Malvinas)",
    "Mammals": 4,
    "Birds": 8,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 8,
    "Molluscs": 0,
    "Other Inverts": 0,
    "Plants": 5,
    "Fungi": 6,
    "Chromists": 0,
    "Total": 31
  },
  {
    "Name": "French Guiana",
    "Mammals": 8,
    "Birds": 3,
    "Reptiles": 7,
    "Amphibians": 4,
    "Fishes": 74,
    "Molluscs": 0,
    "Other Inverts": 1,
    "Plants": 65,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 162
  },
  {
    "Name": "Guyana",
    "Mammals": 11,
    "Birds": 9,
    "Reptiles": 6,
    "Amphibians": 21,
    "Fishes": 93,
    "Molluscs": 0,
    "Other Inverts": 1,
    "Plants": 156,
    "Fungi": 1,
    "Chromists": 0,
    "Total": 298
  },
  {
    "Name": "Paraguay",
    "Mammals": 11,
    "Birds": 27,
    "Reptiles": 12,
    "Amphibians": 1,
    "Fishes": 18,
    "Molluscs": 0,
    "Other Inverts": 2,
    "Plants": 29,
    "Fungi": 4,
    "Chromists": 0,
    "Total": 104
  },
  {
    "Name": "Peru",
    "Mammals": 51,
    "Birds": 82,
    "Reptiles": 33,
    "Amphibians": 139,
    "Fishes": 117,
    "Molluscs": 4,
    "Other Inverts": 7,
    "Plants": 732,
    "Fungi": 2,
    "Chromists": 0,
    "Total": 1167
  },
  {
    "Name": "Suriname",
    "Mammals": 9,
    "Birds": 3,
    "Reptiles": 6,
    "Amphibians": 0,
    "Fishes": 71,
    "Molluscs": 0,
    "Other Inverts": 1,
    "Plants": 66,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 156
  },
  {
    "Name": "Uruguay",
    "Mammals": 9,
    "Birds": 22,
    "Reptiles": 7,
    "Amphibians": 1,
    "Fishes": 83,
    "Molluscs": 0,
    "Other Inverts": 3,
    "Plants": 22,
    "Fungi": 1,
    "Chromists": 0,
    "Total": 148
  },
  {
    "Name": "Venezuela",
    "Mammals": 37,
    "Birds": 35,
    "Reptiles": 33,
    "Amphibians": 127,
    "Fishes": 140,
    "Molluscs": 1,
    "Other Inverts": 59,
    "Plants": 510,
    "Fungi": 3,
    "Chromists": 0,
    "Total": 945
  },
  {
    "Name": "Bangladesh",
    "Mammals": 39,
    "Birds": 34,
    "Reptiles": 30,
    "Amphibians": 0,
    "Fishes": 84,
    "Molluscs": 0,
    "Other Inverts": 7,
    "Plants": 49,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 243
  },
  {
    "Name": "Bhutan",
    "Mammals": 28,
    "Birds": 19,
    "Reptiles": 10,
    "Amphibians": 1,
    "Fishes": 5,
    "Molluscs": 0,
    "Other Inverts": 1,
    "Plants": 63,
    "Fungi": 2,
    "Chromists": 0,
    "Total": 129
  },
  {
    "Name": "British Indian Ocean Territory",
    "Mammals": 0,
    "Birds": 1,
    "Reptiles": 2,
    "Amphibians": 0,
    "Fishes": 27,
    "Molluscs": 0,
    "Other Inverts": 70,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 100
  },
  {
    "Name": "Brunei Darussalam",
    "Mammals": 38,
    "Birds": 41,
    "Reptiles": 10,
    "Amphibians": 2,
    "Fishes": 69,
    "Molluscs": 0,
    "Other Inverts": 18,
    "Plants": 223,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 401
  },
  {
    "Name": "Cambodia",
    "Mammals": 45,
    "Birds": 31,
    "Reptiles": 23,
    "Amphibians": 8,
    "Fishes": 104,
    "Molluscs": 1,
    "Other Inverts": 83,
    "Plants": 91,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 386
  },
  {
    "Name": "Disputed Territory",
    "Mammals": 0,
    "Birds": 0,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 20,
    "Molluscs": 0,
    "Other Inverts": 1,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 21
  },
  {
    "Name": "India",
    "Mammals": 98,
    "Birds": 88,
    "Reptiles": 106,
    "Amphibians": 139,
    "Fishes": 333,
    "Molluscs": 7,
    "Other Inverts": 135,
    "Plants": 637,
    "Fungi": 3,
    "Chromists": 0,
    "Total": 1546
  },
  {
    "Name": "Indonesia",
    "Mammals": 212,
    "Birds": 155,
    "Reptiles": 77,
    "Amphibians": 29,
    "Fishes": 372,
    "Molluscs": 42,
    "Other Inverts": 343,
    "Plants": 1371,
    "Fungi": 2,
    "Chromists": 0,
    "Total": 2603
  },
  {
    "Name": "Lao People's Democratic Republic",
    "Mammals": 49,
    "Birds": 28,
    "Reptiles": 35,
    "Amphibians": 10,
    "Fishes": 56,
    "Molluscs": 16,
    "Other Inverts": 7,
    "Plants": 122,
    "Fungi": 1,
    "Chromists": 0,
    "Total": 324
  },
  {
    "Name": "Malaysia",
    "Mammals": 81,
    "Birds": 67,
    "Reptiles": 60,
    "Amphibians": 41,
    "Fishes": 183,
    "Molluscs": 45,
    "Other Inverts": 284,
    "Plants": 1449,
    "Fungi": 6,
    "Chromists": 0,
    "Total": 2216
  },
  {
    "Name": "Maldives",
    "Mammals": 2,
    "Birds": 0,
    "Reptiles": 3,
    "Amphibians": 0,
    "Fishes": 47,
    "Molluscs": 0,
    "Other Inverts": 45,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 97
  },
  {
    "Name": "Myanmar",
    "Mammals": 54,
    "Birds": 55,
    "Reptiles": 38,
    "Amphibians": 6,
    "Fishes": 105,
    "Molluscs": 3,
    "Other Inverts": 75,
    "Plants": 181,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 517
  },
  {
    "Name": "Nepal",
    "Mammals": 30,
    "Birds": 36,
    "Reptiles": 17,
    "Amphibians": 2,
    "Fishes": 11,
    "Molluscs": 1,
    "Other Inverts": 2,
    "Plants": 31,
    "Fungi": 2,
    "Chromists": 0,
    "Total": 132
  },
  {
    "Name": "Philippines",
    "Mammals": 43,
    "Birds": 91,
    "Reptiles": 36,
    "Amphibians": 27,
    "Fishes": 151,
    "Molluscs": 3,
    "Other Inverts": 353,
    "Plants": 1072,
    "Fungi": 1,
    "Chromists": 0,
    "Total": 1777
  },
  {
    "Name": "Singapore",
    "Mammals": 18,
    "Birds": 22,
    "Reptiles": 8,
    "Amphibians": 0,
    "Fishes": 80,
    "Molluscs": 1,
    "Other Inverts": 179,
    "Plants": 73,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 381
  },
  {
    "Name": "Sri Lanka",
    "Mammals": 29,
    "Birds": 13,
    "Reptiles": 113,
    "Amphibians": 71,
    "Fishes": 138,
    "Molluscs": 0,
    "Other Inverts": 153,
    "Plants": 320,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 837
  },
  {
    "Name": "Thailand",
    "Mammals": 65,
    "Birds": 67,
    "Reptiles": 42,
    "Amphibians": 12,
    "Fishes": 157,
    "Molluscs": 16,
    "Other Inverts": 201,
    "Plants": 298,
    "Fungi": 1,
    "Chromists": 0,
    "Total": 859
  },
  {
    "Name": "Timor-Leste",
    "Mammals": 6,
    "Birds": 8,
    "Reptiles": 3,
    "Amphibians": 0,
    "Fishes": 40,
    "Molluscs": 0,
    "Other Inverts": 1,
    "Plants": 8,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 66
  },
  {
    "Name": "Viet Nam",
    "Mammals": 64,
    "Birds": 51,
    "Reptiles": 75,
    "Amphibians": 73,
    "Fishes": 148,
    "Molluscs": 30,
    "Other Inverts": 161,
    "Plants": 451,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 1053
  },
  {
    "Name": "Angola",
    "Mammals": 23,
    "Birds": 33,
    "Reptiles": 10,
    "Amphibians": 0,
    "Fishes": 83,
    "Molluscs": 7,
    "Other Inverts": 4,
    "Plants": 79,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 239
  },
  {
    "Name": "Benin",
    "Mammals": 16,
    "Birds": 14,
    "Reptiles": 8,
    "Amphibians": 1,
    "Fishes": 74,
    "Molluscs": 3,
    "Other Inverts": 1,
    "Plants": 18,
    "Fungi": 2,
    "Chromists": 0,
    "Total": 137
  },
  {
    "Name": "Botswana",
    "Mammals": 11,
    "Birds": 18,
    "Reptiles": 1,
    "Amphibians": 0,
    "Fishes": 2,
    "Molluscs": 0,
    "Other Inverts": 0,
    "Plants": 3,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 35
  },
  {
    "Name": "Burkina Faso",
    "Mammals": 13,
    "Birds": 15,
    "Reptiles": 4,
    "Amphibians": 0,
    "Fishes": 3,
    "Molluscs": 0,
    "Other Inverts": 0,
    "Plants": 6,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 41
  },
  {
    "Name": "Burundi",
    "Mammals": 16,
    "Birds": 18,
    "Reptiles": 1,
    "Amphibians": 1,
    "Fishes": 16,
    "Molluscs": 3,
    "Other Inverts": 3,
    "Plants": 159,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 217
  },
  {
    "Name": "Cabo Verde",
    "Mammals": 5,
    "Birds": 6,
    "Reptiles": 6,
    "Amphibians": 0,
    "Fishes": 47,
    "Molluscs": 14,
    "Other Inverts": 1,
    "Plants": 51,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 130
  },
  {
    "Name": "Cameroon",
    "Mammals": 49,
    "Birds": 30,
    "Reptiles": 24,
    "Amphibians": 60,
    "Fishes": 154,
    "Molluscs": 14,
    "Other Inverts": 14,
    "Plants": 931,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 1276
  },
  {
    "Name": "Central African Republic",
    "Mammals": 20,
    "Birds": 18,
    "Reptiles": 7,
    "Amphibians": 0,
    "Fishes": 3,
    "Molluscs": 2,
    "Other Inverts": 0,
    "Plants": 54,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 104
  },
  {
    "Name": "Chad",
    "Mammals": 17,
    "Birds": 19,
    "Reptiles": 5,
    "Amphibians": 0,
    "Fishes": 1,
    "Molluscs": 6,
    "Other Inverts": 0,
    "Plants": 8,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 56
  },
  {
    "Name": "Comoros",
    "Mammals": 6,
    "Birds": 13,
    "Reptiles": 9,
    "Amphibians": 0,
    "Fishes": 26,
    "Molluscs": 0,
    "Other Inverts": 81,
    "Plants": 16,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 151
  },
  {
    "Name": "Congo",
    "Mammals": 18,
    "Birds": 6,
    "Reptiles": 8,
    "Amphibians": 1,
    "Fishes": 84,
    "Molluscs": 7,
    "Other Inverts": 0,
    "Plants": 120,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 244
  },
  {
    "Name": "Congo, Democratic Republic of",
    "Mammals": 48,
    "Birds": 40,
    "Reptiles": 18,
    "Amphibians": 13,
    "Fishes": 131,
    "Molluscs": 45,
    "Other Inverts": 9,
    "Plants": 460,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 764
  },
  {
    "Name": "Côte d'Ivoire",
    "Mammals": 34,
    "Birds": 26,
    "Reptiles": 9,
    "Amphibians": 7,
    "Fishes": 90,
    "Molluscs": 8,
    "Other Inverts": 2,
    "Plants": 159,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 335
  },
  {
    "Name": "Djibouti",
    "Mammals": 11,
    "Birds": 15,
    "Reptiles": 1,
    "Amphibians": 0,
    "Fishes": 48,
    "Molluscs": 1,
    "Other Inverts": 56,
    "Plants": 4,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 136
  },
  {
    "Name": "Equatorial Guinea",
    "Mammals": 24,
    "Birds": 3,
    "Reptiles": 8,
    "Amphibians": 6,
    "Fishes": 83,
    "Molluscs": 2,
    "Other Inverts": 2,
    "Plants": 181,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 309
  },
  {
    "Name": "Eritrea",
    "Mammals": 16,
    "Birds": 22,
    "Reptiles": 7,
    "Amphibians": 0,
    "Fishes": 54,
    "Molluscs": 1,
    "Other Inverts": 57,
    "Plants": 7,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 164
  },
  {
    "Name": "Eswatini",
    "Mammals": 9,
    "Birds": 15,
    "Reptiles": 1,
    "Amphibians": 0,
    "Fishes": 5,
    "Molluscs": 0,
    "Other Inverts": 3,
    "Plants": 50,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 83
  },
  {
    "Name": "Ethiopia",
    "Mammals": 40,
    "Birds": 35,
    "Reptiles": 4,
    "Amphibians": 12,
    "Fishes": 15,
    "Molluscs": 4,
    "Other Inverts": 11,
    "Plants": 210,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 331
  },
  {
    "Name": "Gabon",
    "Mammals": 17,
    "Birds": 5,
    "Reptiles": 8,
    "Amphibians": 5,
    "Fishes": 98,
    "Molluscs": 2,
    "Other Inverts": 2,
    "Plants": 501,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 638
  },
  {
    "Name": "Gambia",
    "Mammals": 11,
    "Birds": 19,
    "Reptiles": 6,
    "Amphibians": 0,
    "Fishes": 82,
    "Molluscs": 3,
    "Other Inverts": 0,
    "Plants": 6,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 127
  },
  {
    "Name": "Ghana",
    "Mammals": 23,
    "Birds": 25,
    "Reptiles": 9,
    "Amphibians": 9,
    "Fishes": 88,
    "Molluscs": 9,
    "Other Inverts": 3,
    "Plants": 126,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 292
  },
  {
    "Name": "Guinea",
    "Mammals": 34,
    "Birds": 22,
    "Reptiles": 10,
    "Amphibians": 7,
    "Fishes": 119,
    "Molluscs": 6,
    "Other Inverts": 5,
    "Plants": 226,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 429
  },
  {
    "Name": "Guinea-Bissau",
    "Mammals": 15,
    "Birds": 15,
    "Reptiles": 9,
    "Amphibians": 0,
    "Fishes": 73,
    "Molluscs": 3,
    "Other Inverts": 0,
    "Plants": 12,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 127
  },
  {
    "Name": "Kenya",
    "Mammals": 32,
    "Birds": 45,
    "Reptiles": 22,
    "Amphibians": 15,
    "Fishes": 103,
    "Molluscs": 20,
    "Other Inverts": 79,
    "Plants": 408,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 724
  },
  {
    "Name": "Lesotho",
    "Mammals": 4,
    "Birds": 9,
    "Reptiles": 0,
    "Amphibians": 0,
    "Fishes": 1,
    "Molluscs": 0,
    "Other Inverts": 1,
    "Plants": 5,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 20
  },
  {
    "Name": "Liberia",
    "Mammals": 27,
    "Birds": 14,
    "Reptiles": 9,
    "Amphibians": 2,
    "Fishes": 94,
    "Molluscs": 5,
    "Other Inverts": 7,
    "Plants": 144,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 302
  },
  {
    "Name": "Madagascar",
    "Mammals": 133,
    "Birds": 37,
    "Reptiles": 139,
    "Amphibians": 147,
    "Fishes": 115,
    "Molluscs": 35,
    "Other Inverts": 252,
    "Plants": 2980,
    "Fungi": 1,
    "Chromists": 0,
    "Total": 3839
  },
  {
    "Name": "Malawi",
    "Mammals": 10,
    "Birds": 20,
    "Reptiles": 4,
    "Amphibians": 5,
    "Fishes": 37,
    "Molluscs": 7,
    "Other Inverts": 11,
    "Plants": 64,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 158
  },
  {
    "Name": "Mali",
    "Mammals": 15,
    "Birds": 19,
    "Reptiles": 4,
    "Amphibians": 0,
    "Fishes": 1,
    "Molluscs": 5,
    "Other Inverts": 0,
    "Plants": 29,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 73
  },
  {
    "Name": "Mauritania",
    "Mammals": 19,
    "Birds": 24,
    "Reptiles": 6,
    "Amphibians": 0,
    "Fishes": 79,
    "Molluscs": 3,
    "Other Inverts": 1,
    "Plants": 1,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 133
  },
  {
    "Name": "Mauritius",
    "Mammals": 7,
    "Birds": 12,
    "Reptiles": 15,
    "Amphibians": 0,
    "Fishes": 31,
    "Molluscs": 33,
    "Other Inverts": 93,
    "Plants": 103,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 294
  },
  {
    "Name": "Mayotte",
    "Mammals": 2,
    "Birds": 3,
    "Reptiles": 7,
    "Amphibians": 1,
    "Fishes": 26,
    "Molluscs": 0,
    "Other Inverts": 77,
    "Plants": 14,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 130
  },
  {
    "Name": "Mozambique",
    "Mammals": 19,
    "Birds": 32,
    "Reptiles": 15,
    "Amphibians": 7,
    "Fishes": 112,
    "Molluscs": 0,
    "Other Inverts": 68,
    "Plants": 306,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 559
  },
  {
    "Name": "Namibia",
    "Mammals": 15,
    "Birds": 33,
    "Reptiles": 5,
    "Amphibians": 0,
    "Fishes": 49,
    "Molluscs": 2,
    "Other Inverts": 2,
    "Plants": 66,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 172
  },
  {
    "Name": "Niger",
    "Mammals": 15,
    "Birds": 16,
    "Reptiles": 4,
    "Amphibians": 0,
    "Fishes": 3,
    "Molluscs": 2,
    "Other Inverts": 0,
    "Plants": 4,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 44
  },
  {
    "Name": "Nigeria",
    "Mammals": 36,
    "Birds": 22,
    "Reptiles": 15,
    "Amphibians": 13,
    "Fishes": 104,
    "Molluscs": 5,
    "Other Inverts": 10,
    "Plants": 262,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 467
  },
  {
    "Name": "Réunion",
    "Mammals": 4,
    "Birds": 7,
    "Reptiles": 2,
    "Amphibians": 0,
    "Fishes": 36,
    "Molluscs": 17,
    "Other Inverts": 73,
    "Plants": 24,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 163
  },
  {
    "Name": "Rwanda",
    "Mammals": 24,
    "Birds": 20,
    "Reptiles": 4,
    "Amphibians": 2,
    "Fishes": 6,
    "Molluscs": 0,
    "Other Inverts": 4,
    "Plants": 136,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 196
  },
  {
    "Name": "Saint Helena, Ascension and Tristan da Cunha",
    "Mammals": 3,
    "Birds": 21,
    "Reptiles": 2,
    "Amphibians": 0,
    "Fishes": 20,
    "Molluscs": 1,
    "Other Inverts": 106,
    "Plants": 45,
    "Fungi": 1,
    "Chromists": 0,
    "Total": 199
  },
  {
    "Name": "Sao Tome and Principe",
    "Mammals": 4,
    "Birds": 13,
    "Reptiles": 6,
    "Amphibians": 3,
    "Fishes": 38,
    "Molluscs": 4,
    "Other Inverts": 2,
    "Plants": 73,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 143
  },
  {
    "Name": "Senegal",
    "Mammals": 23,
    "Birds": 23,
    "Reptiles": 9,
    "Amphibians": 0,
    "Fishes": 91,
    "Molluscs": 15,
    "Other Inverts": 1,
    "Plants": 23,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 185
  },
  {
    "Name": "Seychelles",
    "Mammals": 7,
    "Birds": 13,
    "Reptiles": 12,
    "Amphibians": 6,
    "Fishes": 48,
    "Molluscs": 37,
    "Other Inverts": 285,
    "Plants": 60,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 468
  },
  {
    "Name": "Sierra Leone",
    "Mammals": 25,
    "Birds": 17,
    "Reptiles": 10,
    "Amphibians": 1,
    "Fishes": 88,
    "Molluscs": 7,
    "Other Inverts": 5,
    "Plants": 150,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 303
  },
  {
    "Name": "Somalia",
    "Mammals": 18,
    "Birds": 20,
    "Reptiles": 5,
    "Amphibians": 0,
    "Fishes": 65,
    "Molluscs": 2,
    "Other Inverts": 60,
    "Plants": 97,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 267
  },
  {
    "Name": "South Africa",
    "Mammals": 33,
    "Birds": 54,
    "Reptiles": 25,
    "Amphibians": 16,
    "Fishes": 157,
    "Molluscs": 23,
    "Other Inverts": 193,
    "Plants": 460,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 961
  },
  {
    "Name": "South Sudan",
    "Mammals": 18,
    "Birds": 23,
    "Reptiles": 5,
    "Amphibians": 0,
    "Fishes": 0,
    "Molluscs": 0,
    "Other Inverts": 1,
    "Plants": 25,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 72
  },
  {
    "Name": "Sudan",
    "Mammals": 20,
    "Birds": 26,
    "Reptiles": 6,
    "Amphibians": 0,
    "Fishes": 55,
    "Molluscs": 0,
    "Other Inverts": 50,
    "Plants": 17,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 174
  },
  {
    "Name": "Tanzania, United Republic of",
    "Mammals": 45,
    "Birds": 47,
    "Reptiles": 41,
    "Amphibians": 61,
    "Fishes": 225,
    "Molluscs": 11,
    "Other Inverts": 137,
    "Plants": 1048,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 1615
  },
  {
    "Name": "Togo",
    "Mammals": 16,
    "Birds": 15,
    "Reptiles": 9,
    "Amphibians": 2,
    "Fishes": 68,
    "Molluscs": 4,
    "Other Inverts": 1,
    "Plants": 15,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 130
  },
  {
    "Name": "Uganda",
    "Mammals": 32,
    "Birds": 33,
    "Reptiles": 8,
    "Amphibians": 2,
    "Fishes": 55,
    "Molluscs": 17,
    "Other Inverts": 17,
    "Plants": 158,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 322
  },
  {
    "Name": "Zambia",
    "Mammals": 13,
    "Birds": 22,
    "Reptiles": 4,
    "Amphibians": 0,
    "Fishes": 26,
    "Molluscs": 12,
    "Other Inverts": 1,
    "Plants": 70,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 148
  },
  {
    "Name": "Zimbabwe",
    "Mammals": 10,
    "Birds": 22,
    "Reptiles": 5,
    "Amphibians": 6,
    "Fishes": 5,
    "Molluscs": 0,
    "Other Inverts": 8,
    "Plants": 81,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 137
  },
  {
    "Name": "Afghanistan",
    "Mammals": 12,
    "Birds": 15,
    "Reptiles": 3,
    "Amphibians": 1,
    "Fishes": 11,
    "Molluscs": 0,
    "Other Inverts": 2,
    "Plants": 13,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 57
  },
  {
    "Name": "Armenia",
    "Mammals": 7,
    "Birds": 14,
    "Reptiles": 7,
    "Amphibians": 0,
    "Fishes": 4,
    "Molluscs": 0,
    "Other Inverts": 6,
    "Plants": 82,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 120
  },
  {
    "Name": "Azerbaijan",
    "Mammals": 7,
    "Birds": 17,
    "Reptiles": 8,
    "Amphibians": 1,
    "Fishes": 13,
    "Molluscs": 1,
    "Other Inverts": 5,
    "Plants": 50,
    "Fungi": 1,
    "Chromists": 0,
    "Total": 103
  },
  {
    "Name": "Bahrain",
    "Mammals": 3,
    "Birds": 8,
    "Reptiles": 4,
    "Amphibians": 0,
    "Fishes": 39,
    "Molluscs": 0,
    "Other Inverts": 13,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 67
  },
  {
    "Name": "Cyprus",
    "Mammals": 7,
    "Birds": 8,
    "Reptiles": 3,
    "Amphibians": 1,
    "Fishes": 40,
    "Molluscs": 7,
    "Other Inverts": 16,
    "Plants": 23,
    "Fungi": 3,
    "Chromists": 0,
    "Total": 108
  },
  {
    "Name": "Georgia",
    "Mammals": 10,
    "Birds": 15,
    "Reptiles": 6,
    "Amphibians": 0,
    "Fishes": 13,
    "Molluscs": 2,
    "Other Inverts": 10,
    "Plants": 72,
    "Fungi": 5,
    "Chromists": 0,
    "Total": 133
  },
  {
    "Name": "Iran, Islamic Republic of",
    "Mammals": 18,
    "Birds": 28,
    "Reptiles": 15,
    "Amphibians": 5,
    "Fishes": 87,
    "Molluscs": 1,
    "Other Inverts": 21,
    "Plants": 19,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 194
  },
  {
    "Name": "Iraq",
    "Mammals": 13,
    "Birds": 17,
    "Reptiles": 3,
    "Amphibians": 2,
    "Fishes": 49,
    "Molluscs": 0,
    "Other Inverts": 15,
    "Plants": 4,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 103
  },
  {
    "Name": "Israel",
    "Mammals": 17,
    "Birds": 18,
    "Reptiles": 10,
    "Amphibians": 1,
    "Fishes": 91,
    "Molluscs": 11,
    "Other Inverts": 64,
    "Plants": 41,
    "Fungi": 2,
    "Chromists": 0,
    "Total": 255
  },
  {
    "Name": "Jordan",
    "Mammals": 13,
    "Birds": 15,
    "Reptiles": 6,
    "Amphibians": 0,
    "Fishes": 34,
    "Molluscs": 5,
    "Other Inverts": 55,
    "Plants": 8,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 136
  },
  {
    "Name": "Kazakhstan",
    "Mammals": 16,
    "Birds": 26,
    "Reptiles": 1,
    "Amphibians": 2,
    "Fishes": 23,
    "Molluscs": 1,
    "Other Inverts": 5,
    "Plants": 21,
    "Fungi": 1,
    "Chromists": 0,
    "Total": 96
  },
  {
    "Name": "Kuwait",
    "Mammals": 7,
    "Birds": 11,
    "Reptiles": 4,
    "Amphibians": 0,
    "Fishes": 41,
    "Molluscs": 0,
    "Other Inverts": 13,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 76
  },
  {
    "Name": "Kyrgyzstan",
    "Mammals": 5,
    "Birds": 15,
    "Reptiles": 3,
    "Amphibians": 1,
    "Fishes": 12,
    "Molluscs": 0,
    "Other Inverts": 3,
    "Plants": 23,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 62
  },
  {
    "Name": "Lebanon",
    "Mammals": 10,
    "Birds": 11,
    "Reptiles": 7,
    "Amphibians": 0,
    "Fishes": 43,
    "Molluscs": 10,
    "Other Inverts": 9,
    "Plants": 101,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 191
  },
  {
    "Name": "Oman",
    "Mammals": 9,
    "Birds": 13,
    "Reptiles": 8,
    "Amphibians": 0,
    "Fishes": 83,
    "Molluscs": 3,
    "Other Inverts": 29,
    "Plants": 9,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 154
  },
  {
    "Name": "Pakistan",
    "Mammals": 24,
    "Birds": 31,
    "Reptiles": 17,
    "Amphibians": 1,
    "Fishes": 124,
    "Molluscs": 0,
    "Other Inverts": 18,
    "Plants": 23,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 238
  },
  {
    "Name": "Palestine, State of",
    "Mammals": 7,
    "Birds": 15,
    "Reptiles": 4,
    "Amphibians": 0,
    "Fishes": 18,
    "Molluscs": 1,
    "Other Inverts": 2,
    "Plants": 12,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 59
  },
  {
    "Name": "Qatar",
    "Mammals": 4,
    "Birds": 10,
    "Reptiles": 3,
    "Amphibians": 0,
    "Fishes": 46,
    "Molluscs": 0,
    "Other Inverts": 13,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 76
  },
  {
    "Name": "Saudi Arabia",
    "Mammals": 10,
    "Birds": 19,
    "Reptiles": 3,
    "Amphibians": 0,
    "Fishes": 78,
    "Molluscs": 1,
    "Other Inverts": 59,
    "Plants": 5,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 175
  },
  {
    "Name": "Syrian Arab Republic",
    "Mammals": 15,
    "Birds": 17,
    "Reptiles": 9,
    "Amphibians": 0,
    "Fishes": 64,
    "Molluscs": 10,
    "Other Inverts": 13,
    "Plants": 45,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 173
  },
  {
    "Name": "Tajikistan",
    "Mammals": 8,
    "Birds": 14,
    "Reptiles": 7,
    "Amphibians": 0,
    "Fishes": 7,
    "Molluscs": 0,
    "Other Inverts": 3,
    "Plants": 21,
    "Fungi": 1,
    "Chromists": 0,
    "Total": 61
  },
  {
    "Name": "Türkiye",
    "Mammals": 18,
    "Birds": 21,
    "Reptiles": 20,
    "Amphibians": 12,
    "Fishes": 148,
    "Molluscs": 44,
    "Other Inverts": 43,
    "Plants": 138,
    "Fungi": 8,
    "Chromists": 0,
    "Total": 453
  },
  {
    "Name": "Turkmenistan",
    "Mammals": 8,
    "Birds": 18,
    "Reptiles": 6,
    "Amphibians": 0,
    "Fishes": 13,
    "Molluscs": 1,
    "Other Inverts": 6,
    "Plants": 7,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 59
  },
  {
    "Name": "United Arab Emirates",
    "Mammals": 8,
    "Birds": 13,
    "Reptiles": 5,
    "Amphibians": 0,
    "Fishes": 57,
    "Molluscs": 0,
    "Other Inverts": 15,
    "Plants": 0,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 98
  },
  {
    "Name": "Uzbekistan",
    "Mammals": 8,
    "Birds": 18,
    "Reptiles": 9,
    "Amphibians": 0,
    "Fishes": 9,
    "Molluscs": 1,
    "Other Inverts": 2,
    "Plants": 27,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 74
  },
  {
    "Name": "Yemen",
    "Mammals": 12,
    "Birds": 17,
    "Reptiles": 7,
    "Amphibians": 0,
    "Fishes": 71,
    "Molluscs": 2,
    "Other Inverts": 66,
    "Plants": 167,
    "Fungi": 0,
    "Chromists": 0,
    "Total": 342
  }
]